<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps({
  text: { type: String, required: true },
});

const icon = ref('mdi-clipboard-text');

function writeText() {
  icon.value = 'mdi-check';
  navigator.clipboard.writeText(props.text);
  setTimeout(() => {
    icon.value = 'mdi-clipboard-text';
  }, 500);
}
</script>

<template>
  <v-btn icon size="x-small" @click="writeText" variant="plain" title="Copy">
    <v-icon :icon="icon"> </v-icon>
  </v-btn>
</template>
